// Remove Prismic compression params from URL
export const removeCompressionParams = (url) => {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.delete('auto');
  return parsedUrl.toString();
};
